import * as React from "react";

const IconAtomsClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <circle cx={16} cy={16} r={15.5} stroke="#7981B2" />
    <path stroke="#7981B2" strokeLinecap="round" d="m11 11 10 10M21 11 11 21" />
  </svg>
);
export default IconAtomsClose;
